<div class="shadow mb-4 rounded headingtop" [class]="theme.myHeadingColor">
        {{heading}}
</div> 
